const withSuggestionBoxQuest = (SuggestionBoxComponent: any, props: any) => {
  return <SuggestionBoxComponent {...props} />;
};

export default withSuggestionBoxQuest;
